export const ADJUDICACAO = 'ADJUDICACAO';
export const ADJUDICACAO_START = 'ADJUDICACAO_START';
export const ADJUDICACAO_SUCCESS = 'ADJUDICACAO_SUCCESS';
export const ADJUDICACAO_ERROR = 'ADJUDICACAO_ERROR';

export const ADJUDICACAO_ARQUIVOS = 'ADJUDICACAO_ARQUIVOS';
export const ADJUDICACAO_ARQUIVOS_START = 'ADJUDICACAO_ARQUIVOS_START';
export const ADJUDICACAO_ARQUIVOS_SUCCESS = 'ADJUDICACAO_ARQUIVOS_SUCCESS';
export const ADJUDICACAO_ARQUIVOS_ERROR = 'ADJUDICACAO_ARQUIVOS_ERROR';
